
(function () {
  function updateLaborDayProgress(cart) {
    var containers = document.querySelectorAll('#labor-day-cart-progress, .labor-day-cart-progress');
    var bars = document.querySelectorAll('#labor-day-progress-bar, .labor-day-progress-bar');
    var messages = document.querySelectorAll('#labor-day-progress-message, .labor-day-progress-message');
    var remainings = document.querySelectorAll('.labor-day-remaining');

    if (!bars.length && !messages.length && !containers.length) return;

    function applyCartUpdate(cartData) {
      if (!cartData || typeof cartData.total_price === 'undefined') return;

      var isCartEmpty = (typeof cartData.item_count !== 'undefined' && cartData.item_count === 0) ||
        (cartData.items && Array.isArray(cartData.items) && cartData.items.length === 0);

      if (isCartEmpty) {
        containers.forEach(function (container) {
          container.style.display = 'none';
        });
        return;
      }

      // Collect qualifying variant IDs from DOM data attributes
      var qualifyingVariantIds = [];
      document.querySelectorAll('[data-variant-id][data-is-qualifying="true"]').forEach(function (el) {
        var vId = el.getAttribute('data-variant-id');
        if (vId) qualifyingVariantIds.push(parseInt(vId, 10));
      });

      var qualifyingCents = 0;
      var hasQualifyingItem = false;

      if (cartData.items && Array.isArray(cartData.items)) {
        for (var i = 0; i < cartData.items.length; i++) {
          var item = cartData.items[i];
          var itemVariantId = item.variant_id || item.id;
          if (qualifyingVariantIds.indexOf(itemVariantId) !== -1) {
            hasQualifyingItem = true;
            qualifyingCents += item.line_price;
          }
        }
      }

      // No qualifying item in cart -> hide the block completely (no fallback to full cart total)
      if (!hasQualifyingItem) {
        containers.forEach(function (container) {
          container.style.display = 'none';
        });
        return;
      }

      containers.forEach(function (container) {
        container.style.display = 'block';
      });

      var total = qualifyingCents / 100;
      var goal = 2000;
      var percent = Math.min(100, Math.max(0, (total / goal) * 100));

      bars.forEach(function (bar) {
        bar.style.width = percent + '%';
      });

      messages.forEach(function (msg) {
        if (total >= goal) {
          msg.innerHTML = '🎉 <strong>FREE ACCESSORY UP TO $300 UNLOCKED!</strong>' +
            '<div style="margin-top:8px;">' +
            '<a href="/collections/less-300" style="display:inline-block; padding:7px 16px; background:#9f4d04; color:#ffffff; font-size:12px; font-weight:700; border-radius:4px; text-decoration:none; box-shadow:0 2px 4px rgba(0,0,0,0.15);">Select Your Free Accessories &rarr;</a>' +
            '</div>';
        } else {
          var remaining = goal - total;
          var formattedRemaining = '$' + remaining.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
          msg.innerHTML = 'Add <strong>' + formattedRemaining + '</strong> more to unlock your <strong>FREE ACCESSORY!</strong>';
        }
      });

      remainings.forEach(function (el) {
        if (total >= goal) {
          el.innerHTML = '<a href="/collections/less-300" style="color:#9f4d04; text-decoration:underline;">🎉 Unlocked! Select Accessory</a>';
        } else {
          var remaining = goal - total;
          var formattedRemaining = '$' + remaining.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
          el.innerHTML = 'Needed: <strong>' + formattedRemaining + '</strong>';
        }
      });
    }

    if (cart && typeof cart === 'object' && typeof cart.total_price !== 'undefined') {
      applyCartUpdate(cart);
    } else {
      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          applyCartUpdate(cartData);
        })
        .catch(function (error) {
          console.error('Labor Day Progress error:', error);
        });
    }
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      updateLaborDayProgress();
    });
  } else {
    updateLaborDayProgress();
  }

  // Listen to pubsub events if available
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      updateLaborDayProgress();
    });
  }

  // Intercept fetch calls for AJAX cart updates
  var originalFetch = window.fetch;
  if (originalFetch) {
    window.fetch = function () {
      var fetchPromise = originalFetch.apply(this, arguments);
      var url = arguments[0];

      if (typeof url === 'string' && (url.includes('/cart') || url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
        fetchPromise.then(function (response) {
          setTimeout(function () {
            updateLaborDayProgress();
          }, 300);
          return response;
        });
      }
      return fetchPromise;
    };
  }

  // Also update after cart form changes or clicks
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && (e.target.closest('form[action*="/cart"]') || e.target.closest('.mini-cart') || e.target.closest('cart-drawer'))) {
      setTimeout(updateLaborDayProgress, 400);
    }
  });

  // Global helper on window if needed
  window.updateLaborDayProgress = updateLaborDayProgress;
})();